import { h, defineComponent } from 'vue';
import { box } from '@/ui/components';
import { emptyEntry } from '@/ui/pages/EmptyStateEntry';
import { t } from '@/ui/i18n/i18n';

interface ResourceEmptyPageProps {
  message: string;
  illustrationSource: string;
}

export const ResourceEmptyPage = defineComponent<ResourceEmptyPageProps>({
  name: 'ResourceEmptyPage',
  props: ['message', 'illustrationSource'],
  setup(props) {
    return function render() {
      return box([
        emptyEntry(
          props.illustrationSource,
          t('notifications.empty-title'),
          t('notifications.empty'),
        ),
      ]);
    };
  },
});

export const renderResourceEmptyPage = (message: string, illustrationSource: string) => h(ResourceEmptyPage, {
  props: { message, illustrationSource },
});
